import React, {useState, useEffect} from "react"
import {Div, Tag, Text} from "atomize";
import styled, {createGlobalStyle} from "styled-components";
import theme from "../../../Theme/Theme";
import ReactModal from 'react-modal';
import VideoPlayer from "./../VideoPlayer";
import {ReactComponent as CloseIcon} from "../../../Assets/Icons/close.svg";
import { useScrollPosition } from './../../../utils/getScrollPosition';
import ActivitiesGroup from "../ActivitiesGroup";

const GlobalStyle = createGlobalStyle`
  .description p {
    padding: 1rem 0;
  }
  .ReactModal__Content--after-open {
      width: 800px;
      min-height: calc(100vh / 2);
      max-height: calc(100vh - 4rem);
      overflow-x: auto;
      
      left: unset !important;
      right: unset !important;
      bottom: unset !important;
      border: none !important;
      
      padding: 2rem !important;
      
      @media (max-width: 880px) {
        width: unset;
        top: 20px !important;
        left: 20px !important;
        right: 20px !important;
        bottom: 20px !important;
        padding: 1rem !important;
      }
    }
    .ReactModal__Overlay.ReactModal__Overlay--after-open {
      z-index: 200;
    }
    .ReactModal__Overlay {
      background-color: #009bdf6b !important;
      display: flex;
      justify-content: center;
      opacity: 0;
      .ReactModal__Content {
        transform: scale(0);
        transition: transform 250ms ease-in-out;
      }
      transition: opacity 250ms ease-in-out;
    }
    
    .ReactModal__Overlay--after-open{
      .ReactModal__Content {
        transform: scale(1);
      }
        opacity: 1;
    }
    
    .ReactModal__Overlay--before-close{
      .ReactModal__Content {
        transform: scale(0);
      }
      opacity: 0;
    }
    
    // .ReactModal__Body--open {
    //    overflow: hidden;
    // }
    
    .activities {
      color: #4E5D78;	
      font-family: Inter;	
      font-size: 14px;	
      font-weight: 500;	
      line-height: 24px;
    }
`;

const CloseButton = styled.a`
  position: absolute;
  padding: 1rem;
  top: .5rem;
  right: .5rem;
`;

const VideoTitle = styled(Text)`
  color: ${theme.colors.dark};	
  font-family: Inter;
  font-size: 24px;
  color: #0A1F44;
  letter-spacing: 0;
  line-height: 36px;
  margin: 0 2rem 1rem 0;
  font-weight: 600;
  @media (max-width: 880px) {
    margin: 2rem 0 1rem 0;
    font-size: 20px;
    line-height: 32px;
  }
`;

function getParent() {
  return document.querySelector('#root');
}

function VideoModal(props) {
  ReactModal.setAppElement('#main');
  const [playing, setPlaying] = useState(true);

  function closeVideo() {
    setPlaying(false);
  }

  useScrollPosition(({ prevPos, currPos }) => {
    if (props.open) {
      if (props.open) {
        if ( Math.abs(prevPos.y - currPos.y) > 50 ) {
          props.close()
        }
      }
    }
  }, [playing, props.open]);

  useEffect(() => {
    if (!playing) {
      props.close()
    }
  }, [playing]);

  return (
    <>
      <GlobalStyle/>
      <ReactModal
        isOpen={props.open}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => closeVideo()}
        onAfterOpen={() => setPlaying(true)}
        parentSelector={getParent}
        closeTimeoutMS={250}
        data={{
          background: "green"
        }}
      >
        <CloseButton
          aria-label={'close'}
          tabIndex={0}
          onClick={() => closeVideo() }
        >
          <CloseIcon/>
        </CloseButton>
        {props.video.title &&
        <VideoTitle
          as={'h2'}
        >
          {props.video.title}
        </VideoTitle>
        }
        {
          props.mediaObj.field_media_oembed_video &&
          <VideoPlayer
            url={props.mediaObj.field_media_oembed_video}
            playing={playing}
          />
        }
        { props.video.body && props.video.body.value &&
        <div className={'description'} dangerouslySetInnerHTML={{ __html: props.video.body.value }} />
        }
        {
          props.video.field_activities.length > 0 &&
          <div className={'activities'}>
            <h4>Activities</h4>
            <ActivitiesGroup
              activities={props.video.field_activities}
            />
          </div>
        }
      </ReactModal>
    </>
  )
}

export default VideoModal
